import React, {useEffect, useState} from 'react';
import {Button} from 'react-bootstrap';
// import {FaWhatsapp} from 'react-icons/fa';

const WhatsappIcon = () => {
  const [shake, setShake] = useState(false);

  const handleWhatsAppClick = () => {
    window.open('https://wa.me/2349118008008', '_blank');
  };

  useEffect(() => {
    const shakeTimer = setTimeout(() => {
      setShake(true);

      const removeShake = setTimeout(() => setShake(false), 1000);
      return () => clearTimeout(removeShake);
    }, 5000);

    return () => clearTimeout(shakeTimer);
  }, []);
  return (
    <Button
      onClick={handleWhatsAppClick}
      variant='success'
      className={shake ? 'shake-animation krent-whatsapp-launcher' : 'krent-whatsapp-launcher'}
      style={{
        position: 'fixed',
        bottom: 'var(--support-whatsapp-bottom)',
        height: 'var(--support-widget-size)',
        width: 'var(--support-widget-size)',
        right: 'var(--support-widget-right)',
        borderRadius: '50%',
        padding: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.2)',
        zIndex: 20055,
      }}
    >
      {/* <FaWhatsapp size={24} color='white' /> */}
      <i
        className='fa-brands fa-whatsapp text-white'
        style={{ fontSize: 'var(--support-widget-icon-size)' }}
      ></i>
    </Button>
  );
};

export default WhatsappIcon;
